import MenuIcon from "@mui/icons-material/Menu";
import { Select, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="normal" />
			<Text semiBold text="overflow" />
			<Select
				defaultValue="4"
				items={items}
				startIcon={<MenuIcon color="action" />}
			/>
			<Select
				defaultValue="5"
				items={items}
				startIcon={<MenuIcon color="action" />}
				style={{ width: 100 }}
			/>
		</CssColumnGrid>
	);
};